import { createContext, useContext, useMemo, type ReactNode } from 'react';
import type { Source } from '../../types/sources';

interface SourcesContextValue {
  readonly sources: Source[];
}

const SourcesContext = createContext<SourcesContextValue>({ sources: [] });

export interface SourcesProviderProps {
  readonly sources: Source[];
  readonly children: ReactNode;
}

/** Scopes `meta.sources` for the children of a single message. The inline
 *  citation chip reads its lookup map from this context — keeping the
 *  remark plugin agnostic about the surrounding message. */
export function SourcesProvider({ sources, children }: SourcesProviderProps) {
  const value = useMemo<SourcesContextValue>(() => ({ sources }), [sources]);
  return (
    <SourcesContext.Provider value={value}>
      {children}
    </SourcesContext.Provider>
  );
}

export function useMessageSources(): Source[] {
  return useContext(SourcesContext).sources;
}
